module.exports = __webpack_public_path__ + "img/16.80e2dc68.svg";